class PromiseService {
    private readonly ongoingPromises: Map<string, Promise<any>> = new Map();

    async handle<T>(promise: Promise<T>) {
        try {
            return await promise;
        } catch (error) {
            console.error(error);
            return { rejected: true, error };
        }
    }

    /**
     * Executes a promise with deduplication based on a key.
     * If called multiple times with the same key simultaneously, all callers will wait for the same promise.
     * @param key - Unique key to identify the operation
     * @param promiseFactory - Function that returns the promise to execute
     * @returns Promise that resolves when the operation is complete
     */
    async deduplicate<T>(key: string, promiseFactory: () => Promise<T>): Promise<T> {
        if (this.ongoingPromises.has(key)) {
            return this.ongoingPromises.get(key);
        }

        const promise = promiseFactory();
        this.ongoingPromises.set(key, promise);

        try {
            return await promise;
        } finally {
            this.ongoingPromises.delete(key);
        }
    }
}

const promiseService = new PromiseService();

export { promiseService as PromiseService };
